import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { MobileCTA } from "@/components/MobileCTA";
import { Hero } from "@/components/Hero";
import { StatsBand } from "@/components/StatsBand";
import { PromoBanner } from "@/components/PromoBanner";
import { Services } from "@/components/Services";
import { Hauling } from "@/components/Hauling";
import { Proof } from "@/components/Proof";
import { Reviews } from "@/components/Reviews";
import { Pricing } from "@/components/Pricing";
import { Contact } from "@/components/Contact";
import { FAQ } from "@/components/FAQ";
import { Footer } from "@/components/Footer";
import { ChatBot } from "@/components/ChatBot";
import Inbox from "@/pages/Inbox";

const Home = () => (
  <>
    <Navbar />
    <main className="pb-16 lg:pb-0">
      <Hero />
      <PromoBanner />
      <StatsBand />
      <Services />
      <Hauling />
      <Proof />
      <Reviews />
      <Pricing />
      <Contact />
      <FAQ />
    </main>
    <Footer />
    <MobileCTA />
    <ChatBot />
  </>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ anchors: true, smoothWheel: true, lerp: 0.09 });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="grain min-h-screen bg-ink font-body text-offwhite">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/inbox" element={<Inbox />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#161616",
            border: "2px solid #C9A84C",
            color: "#FFFFFF",
            borderRadius: "0",
          },
        }}
      />
    </div>
  );
}

export default App;
